/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_Connect_DescInputs */

const en_domain_search_modal_connect_desc = /** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring a domain you already own`)
};

const es_domain_search_modal_connect_desc = /** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trae un dominio que ya poseas`)
};

const fr_domain_search_modal_connect_desc = /** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apporter un domaine que vous possédez déjà`)
};

const de_domain_search_modal_connect_desc = /** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bringe eine Domain mit, die du bereits besitzt`)
};

/** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */
const ja_domain_search_modal_connect_desc = en_domain_search_modal_connect_desc;

/** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */
const zh_domain_search_modal_connect_desc = en_domain_search_modal_connect_desc;

/** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */
const ar_domain_search_modal_connect_desc = en_domain_search_modal_connect_desc;

/** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */
const id_domain_search_modal_connect_desc = en_domain_search_modal_connect_desc;

/** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */
const it_domain_search_modal_connect_desc = en_domain_search_modal_connect_desc;

/** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */
const ru_domain_search_modal_connect_desc = en_domain_search_modal_connect_desc;

/** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */
const pt_domain_search_modal_connect_desc = en_domain_search_modal_connect_desc;

/** @type {(inputs: Domain_Search_Modal_Connect_DescInputs) => LocalizedString} */
const ko_domain_search_modal_connect_desc = en_domain_search_modal_connect_desc;

/**
* | output |
* | --- |
* | "Bring a domain you already own" |
*
* @param {Domain_Search_Modal_Connect_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_connect_desc = /** @type {((inputs?: Domain_Search_Modal_Connect_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Connect_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_connect_desc(inputs)
	if (locale === "es") return es_domain_search_modal_connect_desc(inputs)
	if (locale === "fr") return fr_domain_search_modal_connect_desc(inputs)
	if (locale === "de") return de_domain_search_modal_connect_desc(inputs)
	if (locale === "ja") return ja_domain_search_modal_connect_desc(inputs)
	if (locale === "zh") return zh_domain_search_modal_connect_desc(inputs)
	if (locale === "ar") return ar_domain_search_modal_connect_desc(inputs)
	if (locale === "id") return id_domain_search_modal_connect_desc(inputs)
	if (locale === "it") return it_domain_search_modal_connect_desc(inputs)
	if (locale === "ru") return ru_domain_search_modal_connect_desc(inputs)
	if (locale === "pt") return pt_domain_search_modal_connect_desc(inputs)
	return ko_domain_search_modal_connect_desc(inputs)
});